<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{data.titlePrefix || (data.data ? 'Edit' : 'Add New')}} {{data.title}}
</h1>
<div mat-dialog-content>
  <form [formGroup]="form">
    @for (field of data.fields; track field; let i = $index) {
      @if (field.sectionTitle) {
        <div class="formSectionTitle">
          {{field.sectionTitle}}
        </div>
      }
      @if (!field.invisible?.(form) && !(fieldsOutsideMatFormField.includes(field.fieldType))) {
        <mat-form-field
          appearance="fill"
          floatLabel="always"
          class="{{field.readOnly ? 'fieldDisabled' : undefined}}"
          >
          <mat-label>{{getFieldLabel(field)}}</mat-label>
          @if (field.help) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              class="fieldHelpButton"
              [matMenuTriggerFor]="fieldHelpMenu"
              aria-label="Show field help"
              (click)="$event.stopPropagation()"
              >
              <mat-icon>help_outline</mat-icon>
            </button>
          }
          <mat-menu #fieldHelpMenu="matMenu" class="fieldHelpMenu" xPosition="before">
            <div class="fieldHelpPanel" (click)="$event.stopPropagation()">
              <div class="fieldHelpTitle">{{field.help?.title}}</div>
              @if (field.help?.description) {
                <div class="fieldHelpDescription">{{field.help?.description}}</div>
              }
              @for (helpGroup of field.help?.groups; track helpGroup) {
                <div class="fieldHelpGroup">
                  <div class="fieldHelpGroupTitle">{{helpGroup.title}}</div>
                  @for (helpField of helpGroup.fields; track helpField) {
                    <code>{{helpField}}</code>
                  }
                </div>
              }
            </div>
          </mat-menu>
          <!-- String Input -->
          @if (field.fieldType === fieldType.F_STRING) {
            <input matInput placeholder="{{field.placeholder || ''}}" [formControlName]="field.name">
          }
          <!-- Number Input -->
          @if (field.fieldType === fieldType.F_NUMBER) {
            <input type="number" matInput placeholder="" [formControlName]="field.name">
          }
          <!-- SSN Input -->
          @if (field.fieldType === fieldType.F_SSN) {
            <input [type]="field.hidePassword ? 'password' : 'text'" pattern="^\d{3}-?\d{2}-?\d{4}$" matInput placeholder="" [formControlName]="field.name">
          }
          @if (field.fieldType === fieldType.F_SSN) {
            <button mat-icon-button matSuffix (click)="field.hidePassword = !field.hidePassword" [attr.aria-label]="'Toggle password visibility'" [attr.aria-pressed]="!field.hidePassword">
              <mat-icon>{{ field.hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          }
          <!-- Phone Input -->
          @if (field.fieldType === fieldType.F_PHONE) {
            <input type="tel" matInput placeholder="" [formControlName]="field.name">
          }
          <!-- Email Input -->
          @if (field.fieldType === fieldType.F_EMAIL) {
            <input type="email" matInput placeholder="" [formControlName]="field.name">
          }
          <!-- Currency Input -->
          @if (field.fieldType === fieldType.F_CURRENCY) {
            <input type="currency" matInput placeholder="" [formControlName]="field.name">
          }
          <!-- Past/Future Date Input -->
          @if (field.fieldType === fieldType.F_PASTDATE || field.fieldType === fieldType.F_FUTUREDATE || field.fieldType === fieldType.F_ANYDATE) {
            <input
              [matDatepicker]="picker" matInput placeholder=""
              [formControlName]="field.name" [min]="field.minDate" [max]="field.maxDate">
          }
          @if (field.fieldType === fieldType.F_PASTDATE || field.fieldType === fieldType.F_FUTUREDATE || field.fieldType === fieldType.F_ANYDATE) {
            <mat-datepicker-toggle matSuffix [for]="picker"
              >
            </mat-datepicker-toggle>
          }
          @if (form.get(field.name)?.value && (field.fieldType === fieldType.F_PASTDATE || field.fieldType === fieldType.F_FUTUREDATE || field.fieldType === fieldType.F_ANYDATE)) {
            <button
              mat-icon-button
              matSuffix
              aria-label="Clear date"
              (click)="form.get(field.name)?.reset()"
              tabindex="-1"
              >
              <mat-icon>close</mat-icon>
            </button>
          }
          <!-- Color selection -->
          <!-- TODO: implement color selector -->
          @if (field.fieldType === fieldType.F_COLOR) {
            <div class="colorField">
              <input matInput placeholder="" [formControlName]="field.name">
              <div class="brandColor" style="background-color: {{form.value[field.name]}}"></div>
            </div>
          }
          <!-- Dropdown -->
          @if (field.fieldType === fieldType.F_DROPDOWN) {
            <mat-select
              [multiple]="field.multiple"
              [formControlName]="field.name"
              placeholder="{{field.placeholder || ''}}"
              [panelClass]="field.searchable ? 'member-addedit-select-search-panel' : ''"
              >
              @if (field.searchable) {
                <mat-option [disabled]="true">
                  <ngx-mat-select-search
                    [formControl]="getDropdownSearchControl(field.name)"
                    noEntriesFoundLabel="No matches"
                    [placeholderLabel]="getSearchPlaceholder(field)"
                  ></ngx-mat-select-search>
                </mat-option>
              }
              @for (value of getFilteredFieldValues(field); track value) {
                <mat-option [value]="value.split(':')[1] || value">
                  {{value.split(':')[0]}}
                </mat-option>
              }
            </mat-select>
          }
          @if (field.fieldType === fieldType.F_STATE) {
            <app-state [formControlName]="field.name"></app-state>
          }
          @if (field.fieldType === fieldType.F_JSON) {
            <app-json [formControlName]="field.name" [readOnly]="!!field.readOnly"></app-json>
          }
          @if (field.hint) {
            <mat-hint>{{field.hint}}</mat-hint>
          }
          <!-- Field validation error display -->
          @if (form.get(field.name)?.hasError('required')) {
            <mat-error>
              {{getFieldLabel(field)}} is required
            </mat-error>
          }
          @if (form.get(field.name)?.hasError('currency')) {
            <mat-error>
              Please enter a valid amount, no $, no commas
            </mat-error>
          }
          @if (form.get(field.name)?.hasError('email')) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
        </mat-form-field>
      }
      <mat-datepicker #picker></mat-datepicker>
      <!-- Slide toggle -->
      <!-- mat-slide-toggle should not be displayed within a mat-form-field, so we create and style
      separately (source: https://material.angular.dev/components/form-field/overview) -->
      @if (field.fieldType === fieldType.F_TOGGLE && !field.invisible?.(form)) {
        <div class="fieldOutsideMatFormField">
          <div>
            <mat-label [id]="field.name + '-label'">{{field.label}}</mat-label>
            @if (field.hint) {
              <div class="fieldHint" [id]="field.name + '-hint'">{{field.hint}}</div>
            }
          </div>
          <mat-slide-toggle [checked]="form.value[field.name]" [formControlName]="field.name"
            [aria-labelledby]="field.name + '-label'"
          [aria-describedby]="field.hint ? field.name + '-hint' : ''"></mat-slide-toggle>
        </div>
      }
      @if (field.fieldType === fieldType.F_ACTION_BUTTON && !field.invisible?.(form)) {
        <div class="fieldOutsideMatFormField actionButtonField">
          <button
            mat-stroked-button
            color="primary"
            type="button"
            [disabled]="isFieldActionDisabled(field)"
            (click)="runFieldAction(field)"
            >
            @if (field.actionIcon) {
              <mat-icon>{{field.actionIcon}}</mat-icon>
            }
            {{getFieldLabel(field)}}
          </button>
        </div>
      }
      @if (field.fieldType === fieldType.F_PRIMARY_INSURANCE_CUSTOM_FIELDS && !field.invisible?.(form)) {
        <div class="primaryInsuranceCustomFieldsEditor">
          <div class="primaryInsuranceCustomFieldsHeader">
            <mat-label>{{field.label}}</mat-label>
            <button mat-stroked-button color="primary" type="button" (click)="addPrimaryInsuranceCustomFieldRow(field.name)">
              Add Field
            </button>
          </div>
          @if (!getPrimaryInsuranceCustomFieldRows(field.name).length) {
            <div class="primaryInsuranceCustomFieldsEmpty">
              No custom fields configured yet.
            </div>
          }
          @for (row of getPrimaryInsuranceCustomFieldRows(field.name); track trackByIndex(rowIndex); let rowIndex = $index) {
            <div
              class="primaryInsuranceCustomFieldRow"
              >
              <mat-form-field appearance="fill">
                <mat-label>Field Name</mat-label>
                <input
                  matInput
                  [ngModel]="row.fieldName"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="eyeColor"
                  (ngModelChange)="updatePrimaryInsuranceCustomField(field.name, rowIndex, 'fieldName', $event)"
                  >
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Label</mat-label>
                <input
                  matInput
                  [ngModel]="row.label"
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Eye Color"
                  (ngModelChange)="updatePrimaryInsuranceCustomField(field.name, rowIndex, 'label', $event)"
                  >
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Type</mat-label>
                <mat-select
                  [ngModel]="row.type"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="updatePrimaryInsuranceCustomField(field.name, rowIndex, 'type', $event)"
                  >
                  @for (type of primaryInsuranceCustomFieldTypes; track type) {
                    <mat-option [value]="type.value">
                      {{type.label}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <button
                mat-icon-button
                type="button"
                aria-label="Remove custom field"
                class="primaryInsuranceCustomFieldRemove"
                (click)="removePrimaryInsuranceCustomFieldRow(field.name, rowIndex)"
                >
                <mat-icon>delete</mat-icon>
              </button>
              @if (row.type === 'dropdown') {
                <mat-form-field appearance="fill" class="primaryInsuranceCustomFieldOptions">
                  <mat-label>Dropdown Options</mat-label>
                  <input
                    matInput
                    [ngModel]="row.optionsText"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Brown, Blue"
                    (ngModelChange)="updatePrimaryInsuranceCustomField(field.name, rowIndex, 'optionsText', $event)"
                    >
                  <mat-hint>Comma-separated values</mat-hint>
                </mat-form-field>
              }
            </div>
          }
          @if (field.hint) {
            <div class="fieldHint">{{field.hint}}</div>
          }
          @if (form.get(field.name)?.invalid && form.get(field.name)?.touched) {
            <div class="fieldError">
              Invalid custom fields. Field name must start with a letter, and dropdowns need at least one option.
            </div>
          }
        </div>
      }
      <!-- Image selection -->
      @if (field.fieldType === fieldType.F_IMAGE && !field.invisible?.(form)) {
        <div >
          <mat-label >{{field.label}}</mat-label>
          <div class="fieldOutsideMatFormField">
            <input
              accept="image/png, image/jpeg"
              type="file"
              id="{{field.name}}FileInput"
              (change)="imageFileChange($event, field.name)"
              >
            @if (form.value[field.name + 'ImageDataSrc'] || form.value[field.name]) {
              <button
                mat-stroked-button
                type="button"
                (click)="clearImageField(field.name)"
                >
                Clear
              </button>
            }
            @if (form.value[field.name + 'ImageDataSrc'] || form.value[field.name]) {
              <img
                alt="{{field.label}}"
                class="brandLogo"
                src="{{form.value[field.name + 'ImageDataSrc'] || form.value[field.name]}}"
                >
            }
          </div>
        </div>
      }
    }
  </form>
  <span class="required">* Required Field</span>
</div>
<div class="buttons" mat-dialog-actions>
  @if (validationMessages.length) {
    <div class="validationBox">
      <h3>Fix these items first</h3>
      <ul>
        @for (message of validationMessages; track message) {
          <li>{{message}}</li>
        }
      </ul>
    </div>
  }
  @if (data.titlePrefix === 'View') {
    <button mat-raised-button class="donebutton" color="primary" (click)="onDismiss()">Close</button>
  } @else {
    <button mat-raised-button class="donebutton" color="primary" [disabled]="isOkDisabled()" (click)="okClicked()">OK</button>
    <button mat-button (click)="onDismiss()">Cancel</button>
  }
</div>
